import { Injectable } from '@angular/core';

@Injectable()
export class DateService {

  private dayString = ['domingo' , 'lunes' , 'martes' , 'miercoles' , ' jueves' , 'viernes' , 'sabado'];
  constructor() {}

  private completeDate(input) {
    return input < 10 ? '0' + input : input;
  }

  /**
   * Format date to dd/MM/yyyy
   */
  public formatDateToShow(date) {
    const dateObject = new Date(date);
    const newDate = `${this.completeDate(dateObject.getDate())}/${this.completeDate(
      dateObject.getMonth() + 1,
    )}/${dateObject.getFullYear()}`;
    return newDate;
  }

  public getDay(date): string {
    const dateObject = new Date(date);
    return this.dayString[dateObject.getDay()];
  }

  public differenceDays(date1: string , date2?: string) {
    const day1 = new Date(date1).getTime();
    const day2 = date2 ?  new Date(date2).getTime() : new Date().getTime();

    const difference = Math.abs(day2 - day1);
    return difference / (1000 * 3600 * 24);
  }
}
